/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type CartRemoveItemLink_portfolioItem$ref: FragmentReference;
export type CartRemoveItemLink_portfolioItem = {|
  +id: string,
  +portfolioId: ?string,
  +portfolioItemId: ?string,
  +$refType: CartRemoveItemLink_portfolioItem$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "CartRemoveItemLink_portfolioItem",
  "type": "PortfolioItemV2",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "id",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "portfolioId",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "portfolioItemId",
      "args": null,
      "storageKey": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'b0a6598c612ce418bd2449600366c5a8';
module.exports = node;
